<template>
	<ul class="buyList">
		<li v-for="(item,index) in buyList" v-if="index > buyListIndex" :key="index">
			<span :data-text="item.nick">{{item.nick}}</span>
			<span>
				<img :src="imgPath+'sales/buy.png'">
				<img :src="imgPath+'sales/'+item.shop_num.toString().substr(0,1)+'.png'">
				<img :src="imgPath+'sales/'+item.shop_num.toString().substr(1,1)+'.png'" v-if="item.shop_num > 9">
				<img :src="imgPath+'sales/Piece.png'">
			</span>
		</li>
	</ul>
</template>

<script>
export default {
	props:['buyList','buyListIndex']
}
</script>

<style scoped>
.buyList {
	position: absolute;
	top: 50%;
	left: 0;
	width: 90%;
	height: 100px;
	margin-top: 100px;
	margin-left: 5%;
	height: 0;
	z-index: 1900;
}

.buyList li {
	line-height: 40px;
	animation: tohide 4s linear;
	opacity: 0;
	position: absolute;
	bottom: 0;
	left: 0;
	text-align: center;
	width: 100%;
}

.buyList img {
	height: 28px;
	vertical-align: middle;
	display: inline-block;
}

.buyList span:nth-child(1) {
	font-size: 22px;
	color: #ff4040;
	position: relative;
	font-weight: bold;
	z-index: 0;
	display: inline-block;
	vertical-align: middle;
}

.buyList span:nth-child(2) {
	display: inline-block;
	font-size: 0;
	vertical-align: middle;
}

.buyList span::before {
	content: attr(data-text);
	display: block;
	position: absolute;
	-webkit-text-stroke: 4px #282828;
	z-index: -1;
}

@keyframes tohide {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0.8;
	}
	100% {
		opacity: 0;
		transform: translateY(-40px);
	}
}
</style>